import { useState } from "react";
import { useOrganizationList } from "@clerk/react";
import { Icone } from "@/components/Icone";
import { mensagemDoErro } from "@/lib/painel/clerk-erros";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field, FieldGroup, FieldLabel } from "@/components/ui/field";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Spinner } from "@/components/ui/spinner";

/**
 * Criação da clínica — nossa tela, não o `<CreateOrganization>` do Clerk.
 *
 * Só o NOME é pedido. Logo, convites e o resto vivem depois, nas
 * configurações: o primeiro passo de quem acabou de entrar tem que ter um
 * campo, não cinco.
 */
export function CriarClinica() {
  const { isLoaded, createOrganization, setActive } = useOrganizationList();
  const [nome, setNome] = useState("");
  const [criando, setCriando] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  async function criar(e: React.FormEvent) {
    e.preventDefault();
    const limpo = nome.trim();
    if (!limpo || criando || !createOrganization || !setActive) return;
    setCriando(true);
    setErro(null);
    try {
      const org = await createOrganization({ name: limpo });
      await setActive({ organization: org.id });
      // Recarrega inteiro: o painel lê a clínica no servidor, e uma navegação
      // de cliente entraria com a sessão anterior ainda em memória.
      window.location.href = "/conversas";
    } catch (err) {
      setErro(mensagemDoErro(err));
      setCriando(false);
    }
  }

  return (
    <form onSubmit={criar}>
      <FieldGroup>
        <Field>
          <FieldLabel htmlFor="nome">Nome da clínica</FieldLabel>
          <Input
            id="nome"
            autoFocus
            maxLength={80}
            placeholder="Ex.: Clínica Aurora, Studio Vittá…"
            className="h-11"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            disabled={criando || !isLoaded}
          />
        </Field>

        {erro ? (
          <Alert variant="destructive">
            <AlertDescription>{erro}</AlertDescription>
          </Alert>
        ) : null}

        <Button type="submit" size="lg" className="w-full" disabled={!nome.trim() || criando || !isLoaded}>
          {criando ? <Spinner /> : null}
          {criando ? "Criando o espaço da clínica…" : "Continuar para o painel"}
          {criando ? null : <Icone nome="seta-direita" className="h-4 w-4" />}
        </Button>
      </FieldGroup>
    </form>
  );
}
